import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button';
import TextArea from '../../../../components/TextArea';
import { VALIDATION_FIELD_MAPPING } from '../../../../utils/appConstant';

interface FooterProps {
  mode: 'edit' | 'view';
  comment: string;
  onCommentChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  saveLoading?: boolean;
  commentError?: string;
}

const Footer: React.FC<FooterProps> = ({
  mode,
  comment,
  onCommentChange,
  onSave,
  onCancel,
  saveLoading,
  commentError,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <hr className="m-0" />
      <div className="card-body">
        <TextArea
          id={VALIDATION_FIELD_MAPPING.comment}
          name={VALIDATION_FIELD_MAPPING.comment}
          rows={3}
          placeholder={t('monthlyStock.verifyStock.pageTexts.footer.commentsPlaceholder')}
          value={comment}
          onChange={(e) => onCommentChange(e.target.value)}
          disabled={mode === 'view'}
        />
        {commentError && (
          <div className="text-danger small mt-1">{commentError}</div>
        )}
      </div>
      <hr className="m-0" />
      <div className="p-4 d-flex justify-content-end gap-2">
        {mode === 'view' ? (
          <Button
            className="btn btn-outline-secondary waves-effect"
            text={t('monthlyStock.verifyStock.pageTexts.footer.buttons.goToList')}
            onClick={onCancel}
          />
        ) : (
          <>
            <Button
              className="btn btn-primary waves-effect waves-light"
              text={t('monthlyStock.verifyStock.pageTexts.footer.buttons.save')}
              loading={saveLoading}
              onClick={onSave}
            />
            <Button
              className="btn btn-outline-secondary waves-effect"
              text={t('monthlyStock.verifyStock.pageTexts.footer.buttons.cancel')}
              onClick={onCancel}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Footer;
